import { render, staticRenderFns } from "./ProductTabSidebar.vue?vue&type=template&id=b1b07fe2&scoped=true"
import script from "./ProductTabSidebar.vue?vue&type=script&lang=js"
export * from "./ProductTabSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductTabSidebar.vue?vue&type=style&index=0&id=b1b07fe2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b07fe2",
  null
  
)

export default component.exports